/**
 * Radiance Theme JS
 *
 * Dependencies:
 * - hoverintent.jquery.js
 *
 */



/**
 * Look under your chair! console.log FOR EVERYONE!
 *
 * @see http://paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
 */
(function(b){function c(){}for(var d="assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,timeStamp,profile,profileEnd,time,timeEnd,trace,warn".split(","),a;a=d.pop();){b[a]=b[a]||c}})((function(){try
{console.log();return window.console;}catch(err){return window.console={};}})());



/**
 * Page-specific call-backs
 * Called after dom has loaded.
 */
var RADIANCE = {

  common : {
    init: function(){
      $('html').removeClass('no-js').addClass('js');
      setupDropdownMenus();
      searchPlaceholder();

      $('.nav-arrow', '#top-menu').each( function(){
        $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
      });

    }
  },

  templateIndex : {
    init: function(){
      if( $("#carousel").length > 0 ){
       $("#carousel").scrollable({
    circular: true
    }).navigator({
      navi: "#carousel-slide-menu",
      naviItem: 'li'
    });

        if ( $("#carousel").find('.items li[class!=cloned]').length > 1 ) {
          window.api = $("#carousel").autoscroll({
            autoplay: true,
            api: true,
            interval: 7500
          })
          $("#carousel").hover(
              function() {
                api.pause();
                $(this).find('.browse').fadeIn('fast');
              },
              function() {
                api.play();
                $(this).find('.browse').fadeOut('fast');
              }
          );
        }

        $('#carousel-thumbs li:first a').addClass('active');
      }
    }
  },

  templateProduct : {
    init: function(){
      $('#add-to-cart').bind( 'click', addToCart );
      $('#product-gallery.zoom-in').enhanceGallery();
      $('#thumbs li:nth-child(5n+5)').addClass('last-in-row');
    }
  },

  templateCart : {
    init: function(){
      $('#toggle-note').toggle(
        function(){ $('#checkout-addnote').find('textarea').show(); },
        function(){ $('#checkout-addnote').find('textarea').hide();  }
      );

    }
  }

}



/**
 * Fire function based upon attributes on the body tag.
 * This is the reason for "template{{ template | camelize }}" in layout/theme.liquid
 *
 * @see http://paulirish.com/2009/markup-based-unobtrusive-comprehensive-dom-ready-execution/
 */
var UTIL = {

  fire : function(func,funcname, args){
    var namespace = RADIANCE;
    funcname = (funcname === undefined) ? 'init' : funcname;
    if (func !== '' && namespace[func] && typeof namespace[func][funcname] == 'function'){
      namespace[func][funcname](args);
    }
  },

  loadEvents : function(){
    var bodyId = document.body.id;

    // hit up common first.
    UTIL.fire('common');

    // do all the classes too.
    $.each(document.body.className.split(/\s+/),function(i,classnm){
      UTIL.fire(classnm);
      UTIL.fire(classnm,bodyId);
    });
  }

};
$(document).ready(UTIL.loadEvents);



/**
 * Balances the height of rows of products/collections.
 * Finds the tallest item in a row, makes each <li> in that row as tall as the tallest.
 */
$.fn.balanceRowHeight = function(numPerRow) {
  var nPerRow = numPerRow || 4;
  var nItems = $(this).find('li').length;
  var nRows = Math.round( nItems / nPerRow );

  for( var row = 1; row <= nRows; row++ ){
    var min = row * nPerRow - nPerRow;
    var max = row * nPerRow;
    var tallestInRow = 0;
    var tallestTitleInRow = 0;

    $(this).find('li').slice(min, max).each(function(){
      if( $(this).height() > tallestInRow ){
        tallestInRow = $(this).height();
      }
      if( $(this).find('.product-information:first').height() > tallestTitleInRow ){
        tallestTitleInRow = $(this).find('.product-information').height();
      }
    }).height(tallestInRow).addClass('generated-height');
  }

  return this;
};

/**
 * Balance product grid height after all images have loaded.
 */
$(window).load( function(){
  if( $('body').hasClass('templateIndex') ){
    // homepage has two grids, needs a bit of special treatment:
//    $('#featured-grid').balanceRowHeight(3);
//    $('#secondary-grid').balanceRowHeight(4);
//    $('#collection-grid').balanceRowHeight(4);
  } else {
//    $('.product-grid').balanceRowHeight(4);
  }
});


function makeSquare() {
  $('.product-grid-image-div').each( function(){
    var width = $(this).width();
	$(this).height( width );
  }); 
}

$(window).load( function(){
  makeSquare();  
});
$(window).resize( function(){
  makeSquare();  
});


/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
  $('#top-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );

  function navRollOver(e){
    $(this).addClass('active').find('ul:first').css('top', $(this).height()).show();
  }
  function navRollOut(e){
    $(this).removeClass('active').find('ul:first').hide();
  }

}



/**
 * Ajaxy add-to-cart
 */
function addToCart(e){

  if (typeof e !== 'undefined') e.preventDefault();

  var form      = $(this).parents('form');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    async: false,
    data: form.serialize(),
    dataType: 'json',
    error: addToCartFail,
    success: addToCartSuccess,
    cache: false
  });

}

function addToCartSuccess (jqXHR, textStatus, errorThrown){

  $.ajax({
    type: 'GET',
    url: '/cart.js',
    async: false,
    cache: false,
    dataType: 'json',
    success: updateCartDesc
  });
  $('#add-to-cart-msg').hide().addClass('success').html('Item added to cart! <a href="/cart" title="view cart">View cart and check out &raquo;</a>').fadeIn();
}

function addToCartFail(jqXHR, textStatus, errorThrown){
  var response = $.parseJSON(jqXHR.responseText);
  $('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
}

function updateCartDesc(data){
  var $cartLinkText = $('.cart-link .icon:first');

  switch(data.item_count){
    case 0:
      $cartLinkText.text('0 items');
      break;
    case 1:
      $cartLinkText.text('1 item');
      break;
    default:
      $cartLinkText.text(data.item_count+' items');
      break;
  }
}

$('#mobile_menu_close').on('click', function(){
  $('#mobile_menu').removeClass('mobile-view');
});

$('#mobile_menu_button').on('click', function(){
  $('#mobile_menu').toggleClass('mobile-view');
});

$("ul.sub-menu").parents('li').addClass('menu-parent arrow');


$('.show-hide-icon').on("click", function( event ) {
  event.stopPropagation();
  $(this).parent('li.menu-parent').toggleClass('expanded');
});

/**
 * Enable placeholder switcheroo in older browsers.
 * @see http://webdesignerwall.com/tutorials/cross-browser-html5-placeholder-text
 */
function searchPlaceholder(){

  if(!Modernizr.input.placeholder){
    $('#top-search-input').focus(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
      input.val('');
      input.removeClass('placeholder');
      }
    }).blur(function() {
      var input = $(this);
      if (input.val() == '' || input.val() == input.attr('placeholder')) {
      input.addClass('placeholder');
      input.val(input.attr('placeholder'));
      }
    }).blur();
    $('[placeholder]').parents('form').submit(function() {
      $(this).find('[placeholder]').each(function() {
      var input = $(this);
      if (input.val() == input.attr('placeholder')) {
        input.val('');
      }
      })
    });
  }

}


function sidebarToggle(element, menu_list) {
  
  // is the product list invisible?
  if (document.getElementById(menu_list).style.display == "none") {  
    // make it visible
    document.getElementById(menu_list).style.display = "block";
    // make icon into a minus:
	$(element).attr('src', '//cdn.shopify.com/s/files/1/0549/6625/t/2/assets/minus.png?69');
  } else {
    // else, hide it again
    document.getElementById(menu_list).style.display = "none";
    // make icon into a plus:
    $(element).attr('src', '//cdn.shopify.com/s/files/1/0549/6625/t/2/assets/plus.png?69');
  }
  
}


/**
For in-store pickup, we utilise a free item with weiight of 1000 kg,
This triggers inclusion of a 'free shipping' option called 'Pickup in store'
We want to have a tickbox which adds/remove this product on the cart page
*/


function adjustPageHeight() {

    var header = $('#top');
    var menu = $('#top-menu');
    var footer = $('#bottom');
    var content = $('#col-main');
    
 	// we'll take into account the padding on the white content area
 	var content_padding = content.outerHeight() - content.height();
 	// calculate optimal height
   var height = $(document).height() - header.outerHeight(true) - footer.outerHeight(true) - menu.outerHeight(true) - content_padding;
   // set optimal height
   content.css("min-height", height);
	
} // end of adjustPageHeight

// trigger the function on load and page resize
$(document).ready( adjustPageHeight );
$(window).resize( adjustPageHeight );


$(document).ready(function() {

  $('#showLayBuy').on('click', function(a){
    a.preventDefault();
    
    // for mobile, bring the laybuy popup down, otherwise it appears too far up towards the top
    var offset = $('#showLayBuy').offset().top;
    if ($(window).width() < 750) {
      $('.laybuyPop').css({'top' : offset + 'px'});
    }
      
    $('.popupbg').show();
    $('.laybuyPop').show();
  });
   
  $('.popupclose').on('click', function(){
    $('.popupbg').hide();
    $('.laybuyPop').hide(); 
  });
  
});